import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Headphone = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 17"
      {...rest}
      fill={fill}
    >
      <path d="M11.001 1.361c.617.004 1.22.186 1.736.524.548.36 1.015.83 1.37 1.382a8.05 8.05 0 0 1 1.228 4.427v7.333a.333.333 0 0 1-.334.334h-2a.333.333 0 0 1-.333-.334V7.694c0-.057 0-.116-.002-.175A2.994 2.994 0 0 1 11 8.028a2.336 2.336 0 0 1-2.333-2.334v-2a2.336 2.336 0 0 1 2.333-2.333Zm3.667 13.333v-7a7.38 7.38 0 0 0-1.116-4.057c-.691-1.038-1.597-1.609-2.55-1.609a1.669 1.669 0 0 0-1.667 1.667v2A1.669 1.669 0 0 0 11 7.36a2.325 2.325 0 0 0 1.71-.754.333.333 0 0 1 .578.194c.03.32.046.612.046.893v7h1.333ZM5 1.361a2.336 2.336 0 0 1 2.334 2.334v2a2.336 2.336 0 0 1-2.333 2.333 2.994 2.994 0 0 1-1.665-.509l-.002.175v7.333a.333.333 0 0 1-.333.334H1a.333.333 0 0 1-.334-.334V7.694a8.05 8.05 0 0 1 1.228-4.427 4.687 4.687 0 0 1 1.37-1.382 3.204 3.204 0 0 1 1.736-.524Zm0 6a1.669 1.669 0 0 0 1.667-1.667v-2a1.669 1.669 0 0 0-1.666-1.666c-.954 0-1.86.571-2.551 1.609a7.38 7.38 0 0 0-1.116 4.057v7h1.333v-7a9.3 9.3 0 0 1 .046-.893.333.333 0 0 1 .578-.194A2.325 2.325 0 0 0 5 7.361Z" />
      <path d="M5.001 5.695a.333.333 0 0 1-.333-.333V4.029a.333.333 0 0 1 .667 0v1.333A.333.333 0 0 1 5 5.695ZM11.001 5.695a.333.333 0 0 1-.333-.333V4.029a.333.333 0 1 1 .667 0v1.333a.333.333 0 0 1-.334.333Z" />
    </svg>
  );
};

Headphone.category = 'product-category';

Headphone.displayName = 'Headphone';
